import(/* webpackMode: "eager" */ "/vercel/path0/web/web/src/app/support/page.tsx");
